import { Transaction } from '../types';
import { sellerDetailView, buyerDetailView } from '../../utils/navigation';

export const createTransactionLink = (transaction: Transaction) => {
    const { role, adIds, transactionId } = transaction;
    if (role === 'SELLER' && adIds) {
        return sellerDetailView(adIds);
    }

    if (role === 'BUYER' && transactionId) {
        return buyerDetailView(transactionId.toString());
    }

    console.error(`User with role ${role} is missing transaction/ad ID`);
    return '';
};
